/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcknowledgeCurrentUserPylonPendingMessageRequest
 */
export interface AcknowledgeCurrentUserPylonPendingMessageRequest {
    /**
     * Pylon message id the client already opened the widget for
     */
    message_id: string;
}

/**
 * Check if a given object implements the AcknowledgeCurrentUserPylonPendingMessageRequest interface.
 */
export function instanceOfAcknowledgeCurrentUserPylonPendingMessageRequest(value: object): value is AcknowledgeCurrentUserPylonPendingMessageRequest {
    if (!('message_id' in value) || value['message_id'] === undefined) return false;
    return true;
}

export function AcknowledgeCurrentUserPylonPendingMessageRequestFromJSON(json: any): AcknowledgeCurrentUserPylonPendingMessageRequest {
    return AcknowledgeCurrentUserPylonPendingMessageRequestFromJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeCurrentUserPylonPendingMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message_id': json['message_id'],
    };
}

export function AcknowledgeCurrentUserPylonPendingMessageRequestToJSON(json: any): AcknowledgeCurrentUserPylonPendingMessageRequest {
    return AcknowledgeCurrentUserPylonPendingMessageRequestToJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessageRequestToJSONTyped(value?: AcknowledgeCurrentUserPylonPendingMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_id': value['message_id'],
    };
}

